<template>
  <div class="container-fluid app app--red">
    <div class="app__width-container">
      <header class="app__title">
        <h1><span>raz</span>pisi za NVO</h1>
      </header>
      <div class="row">
        <div class="col-md-8 col-md-offset-2">
          <div class="filters-container">
            <form @submit.prevent>
              <div class="row simple-search">
                <div class="col-md-6 col-sm-6" v-for="(filter, index) in filters" :key="filter.id">
                  <div class="checkbox">
                    <input type="checkbox" :id="'check-' + index" value="filter.label" :checked="filter.selected" @change="e => { filter.selected = e.target.checked; }">
                    <label :for="'check-' + index"> <span>{{filter.label}}</span></label>
                  </div>
                </div>
              </div>
              <div class="row buttons">
                <div class="col-xs-6">
                  <button class="btn btn-link" @click.prevent="uncheckAll" v-text="uncheckAllText"></button>
                </div>
                <div class="col-xs-6 text-right">
                  <button class="btn btn-link" @click.prevent="toggleAdvanced" v-if="activeTab === 0">napredno iskanje</button>
                </div>
              </div>
              <div class="row advanced-search" v-if="showAdvanced">
                <div class="container-fluid">
                  <div class="row">
                    <h4>Išči po ključnih besedah</h4>
                    <input class="form-control" placeholder="išči" v-model="searchInput" />
                  </div>
                  <div class="row">
                    <h4>Vrsta</h4>
                    <div class="col-md-6 col-sm-6" v-for="(filter, index) in filtersType" :key="filter.id">
                      <div class="checkbox">
                        <input type="checkbox" :id="'check2-' + index" value="filter.label" :checked="filter.selected" @change="e => { filter.selected = e.target.checked; }">
                        <label :for="'check2-' + index"> {{filter.label}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <h4>Programi</h4>
                    <search-dropdown class="dropdown-filter" :items="programs" :placeholder="programsPlaceholder"></search-dropdown>
                  </div>
                  <div class="row" v-if="isSelectedSLO">
                    <h4>Regije (SLO)</h4>
                    <div class="col-md-6 col-sm-6" v-for="(filter, index) in filtersRegion" :key="filter.id">
                      <div class="checkbox">
                        <input type="checkbox" :id="'check3-' + index" value="filter.label" :checked="filter.selected" @change="e => { filter.selected = e.target.checked; }">
                        <label :for="'check3-' + index"> {{filter.label}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="tabs">
          <ul class="nav nav-tabs">
            <li v-for="(tab, index) in tabs" :key="tab.id" :class="{ active: activeTab === index }" @click.prevent="changeTab(index)">
              <a :href="tab.link">{{tab.label}}</a>
              <div class="box__arrow-box"></div>
              <div class="box__arrow"></div>
            </li>
          </ul>
        </div>
      </div> -->
      <div class="table-container">
        <template v-if="activeTab === 0">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th><button class="action" v-sortarrow="'naziv'">NASLOV RAZPISA</button></th>
                  <th><button class="action" v-sortarrow="'datum_objave'">OBJAVLJEN</button></th>
                  <th><button class="action" v-sortarrow="'rok_prijave'">ROK PRIJAVE</button></th>
                  <th><button class="action" v-sortarrow="'razpisovalec'">RAZPISOVALEC</button></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="data_razpisi == null" class="no-hover">
                  <td colspan="4">Nalaganje...</td>
                </tr>
                <tr v-else-if="data_razpisi.error" class="no-hover">
                  <td colspan="4">Napaka pri nalaganju.</td>
                </tr>
                <tr v-else-if="filteredRazpisi && filteredRazpisi.length <= 0" class="no-hover">
                  <td colspan="4">Ni rezultatov.</td>
                </tr>
                <tr v-else v-for="razpis in filteredRazpisi" :key="razpis.id" @click="openCover($event, razpis, 'razpis')" class="razpis-row">
                  <td data-label="NASLOV RAZPISA"><a :href="`/razpisi/razpis/${razpis.id}/${razpis.slug}`">{{razpis.naziv}}</a></td>
                  <td data-label="OBJAVLJEN" v-text="getDateDisplay(razpis.datum_objave)"></td>
                  <td data-label="ROK PRIJAVE" v-text="getDateDisplay(razpis.rok_prijave)"></td>
                  <td data-label="RAZPISOVALEC">{{razpis.razpisovalec}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-if="activeTab === 1">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th><button class="action" v-sortarrow="'naziv'">NASLOV PROGRAMA</button></th>
                  <th><button class="action" v-sortarrow="'organ_upravljanja'">ORGAN UPRAVLJANJA</button></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="data_programi == null" class="no-hover">
                  <td colspan="2">Nalaganje...</td>
                </tr>
                <tr v-else-if="data_programi.error" class="no-hover">
                  <td colspan="2">Napaka pri nalaganju.</td>
                </tr>
                <tr v-else-if="filteredProgrami && filteredProgrami.length <= 0" class="no-hover">
                  <td colspan="2">Ni rezultatov.</td>
                </tr>
                <tr v-else v-for="program in filteredProgrami" :key="program.id" @click="openCover($event, program, 'program')">
                  <td data-label="NASLOV PROGRAMA"><a :href="`/razpisi/program/${program.id}/${program.slug}`">{{program.naziv}}</a></td>
                  <td data-label="ORGAN UPRAVLJANJA">{{program.organ_upravljanja}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-if="activeTab === 2">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th><button class="action" v-sortarrow="'naziv'">IME FUNDACIJE</button></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="data_fundacije == null" class="no-hover">
                  <td>Nalaganje...</td>
                </tr>
                <tr v-else-if="data_fundacije.error" class="no-hover">
                  <td>Napaka pri nalaganju.</td>
                </tr>
                <tr v-else-if="filteredFundacije && filteredFundacije.length <= 0" class="no-hover">
                  <td>Ni rezultatov.</td>
                </tr>
                <tr v-else v-for="fundacija in filteredFundacije" :key="fundacija.id" @click="openCover($event, fundacija, 'fundacija')">
                  <td data-label="IME FUNDACIJE"><a :href="`/razpisi/fundacija/${fundacija.id}/${fundacija.slug}`">{{fundacija.naziv}}</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
      <div class="content-container-cover" v-if="coverOpen && coverData">
        <div class="page-breadcrumbs" v-breadcrumbsclone></div>
        <div class="container-fluid app app--red">
          <div class="app__width-container">
            <div class="top-bar clearfix">
              <a class="top-bar__close" @click.prevent="closeCover" href="/razpisi/">nazaj na rezultate</a>
              <span class="top-bar__title"><span>raz</span>pisi za NVO</span>
            </div>
            <div class="info__title">
              <!--<small>ORGANISATION</small>-->
              <h1>{{coverData.naziv}}</h1>
            </div>
            <div class="row">
              <div class="col-md-4">
                <dl class="side-box side-box--bg">
                  <template v-if="coverData.razpisovalec">
                    <dt>Razpisuje</dt>
                    <dd>{{coverData.razpisovalec}}</dd>
                  </template>
                  <template v-if="coverData.organ_upravljanja">
                    <dt>Organ upravljanja</dt>
                    <dd>{{coverData.organ_upravljanja}}</dd>
                  </template>
                  <template v-if="coverData.program && coverData.program.length">
                    <dt>Programi</dt>
                    <dd>
                      <div v-for="prog in coverData.program" :key="prog.id"><a :href="`/razpisi/program/${prog.id}/${prog.slug}`">{{prog.label}}</a></div>
                    </dd>
                  </template>
                  <template v-if="coverData.vrednost">
                    <dt>Vrednost razpisa</dt>
                    <dd>{{coverData.vrednost}}</dd>
                  </template>
                  <template v-if="coverData.delezi_financiranja">
                    <dt>Zneski in deleži financiranja</dt>
                    <dd>{{coverData.delezi_financiranja}}</dd>
                  </template>
                  <template v-if="coverData.financna_perspektiva">
                    <dt>Finančna perspektiva</dt>
                    <dd>{{coverData.financna_perspektiva}}</dd>
                  </template>
                  <template v-if="coverData.proracun">
                    <dt>Proračun</dt>
                    <dd>{{coverData.proracun}}</dd>
                  </template>
                  <template v-if="coverData.datum_objave">
                    <dt>Datum objave na razpisi.info</dt>
                    <dd>{{new Date(coverData.datum_objave).toLocaleDateString('sl')}}</dd>
                  </template>
                  <template v-if="coverData.rok_prijave">
                    <dt>Rok prijave</dt>
                    <dd>{{new Date(coverData.rok_prijave).toLocaleDateString('sl')}}</dd>
                  </template>
                  <template v-if="coverData.trajanje_projekta">
                    <dt>Trajanje projekta</dt>
                    <dd>{{coverData.trajanje_projekta}}</dd>
                  </template>
                </dl>
                <dl class="side-box side-box--border" v-if="coverData.informacije">
                  <dt class="side-box__title--with-icon">Domača stran razpisa <a :href="coverData.informacije" class="homepage-link" target="_blank"></a></dt>
                </dl>
              </div>
              <div class="col-md-8 main-content">
                <div class="main-content__full-bg block-paragraph" v-html="coverData.opis" v-externallinks v-tooltips></div>
                <div>
                  <template v-if="coverData.opis_ostalo">
                    <div v-html="coverData.opis_ostalo" v-externallinks v-tooltips class="block-paragraph"></div>
                  </template>
                  <template v-if="coverData.upraviceni_prijavitelji">
                    <div class="main-content__title">Upravičeni prijavitelji</div>
                    <div v-html="coverData.upraviceni_prijavitelji" v-externallinks v-tooltips class="block-paragraph"></div>
                  </template>
                  <template v-if="coverData.komu_je_namenjen">
                    <div class="main-content__title">Komu je program namenjen</div>
                    <div v-html="coverData.komu_je_namenjen" v-externallinks v-tooltips class="block-paragraph"></div>
                  </template>
                  <template v-if="coverData.podrocja_financiranja">
                    <div class="main-content__title">Področja financiranja</div>
                    <div v-html="coverData.podrocja_financiranja" v-externallinks v-tooltips class="block-paragraph"></div>
                  </template>
                  <template v-if="coverData.komu_je_namenjena">
                    <div class="main-content__title">Kdo lahko kandidira za sredstva</div>
                    <div v-html="coverData.komu_je_namenjena" v-externallinks v-tooltips class="block-paragraph"></div>
                  </template>
                  <template v-if="coverData.nacionalna_kontaktna_tocka">
                    <div class="main-content__title">Nacionalna kontaktna točka</div>
                    <div v-html="coverData.nacionalna_kontaktna_tocka" v-externallinks v-tooltips class="block-paragraph"></div>
                  </template>
                  <template v-if="coverData.postopek_prijave">
                    <div class="main-content__title">Postopek prijave</div>
                    <div v-html="coverData.postopek_prijave" v-externallinks v-tooltips class="block-paragraph"></div>
                  </template>
                  <template v-if="coverData.dobro_je_vedeti">
                    <div class="main-content__title">Dobro je vedeti</div>
                    <div v-html="coverData.dobro_je_vedeti" v-externallinks v-tooltips class="block-paragraph"></div>
                  </template>
                  <template v-if="coverData.odprti_razpisi && coverData.odprti_razpisi.length">
                    <div class="side-box side-box--border">
                      <dt>Odprti razpisi</dt>
                      <dd>
                        <ul class="main-content__list">
                          <li v-for="f in coverData.odprti_razpisi" :key="f.id"><a :href="`/razpisi/razpis/${f.id}/${f.slug}`">{{f.naziv}}</a></li>
                        </ul>
                      </dd>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid footer-container" v-footerclone></div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import 'bootstrap/js/tooltip';
import 'bootstrap/js/transition';
import 'bootstrap/js/collapse';
import _ from 'lodash';
import SearchDropdown from './components/SearchDropdown.vue';
import { splitFirstParagraph } from './utils';

export default {
  name: 'app',
  created() {
    if (this.coverOpen) {
      const scroller = document.scrollingElement || document.documentElement;
      scroller.style.overflow = 'hidden';
    }
    this.locationChange(window.location);
    window.addEventListener('popstate', () => {
      this.locationChange(window.location);
    });
  },
  data() {
    return {
      tabs: [
        { id: 0, label: 'razpisi', link: '/razpisi/' },
        // { id: 1, label: 'skladi in programi', link: '/razpisi/programi/' },
        // { id: 2, label: 'fundacije', link: '/razpisi/fundacije/' },
      ],
      filters: [
        { id: 0, label: 'Človekove pravice, demokracija in enakost', selected: true },
        { id: 1, label: 'Izobraževanje, raziskave in razvoj', selected: true },
        { id: 2, label: 'Kultura', selected: true },
        { id: 3, label: 'Mladina, otroci', selected: true },
        { id: 4, label: 'Razvojno sodelovanje', selected: true },
        { id: 5, label: 'Sociala', selected: true },
        { id: 6, label: 'Šport', selected: true },
        { id: 7, label: 'Okolje, narava in prostor', selected: true },
        { id: 8, label: 'Zdravje', selected: true },
        { id: 9, label: 'Drugo', selected: true },
      ],
      filtersType: [
        { id: 0, label: 'EU', selected: true },
        { id: 1, label: 'SLO', selected: true },
      ],
      filtersRegion: [
        { id: 0, label: 'Gorenjska', selected: true },
        { id: 1, label: 'Goriška', selected: true },
        { id: 2, label: 'Jugovzhodna Slovenija', selected: true },
        { id: 3, label: 'Koroška', selected: true },
        { id: 4, label: 'Notranjskokraška', selected: true },
        { id: 5, label: 'Obalnokraška', selected: true },
        { id: 6, label: 'Osrednjeslovenska', selected: true },
        { id: 7, label: 'Podravska', selected: true },
        { id: 8, label: 'Pomurska', selected: true },
        { id: 9, label: 'Posavska', selected: true },
        { id: 10, label: 'Savinjska', selected: true },
        { id: 11, label: 'Zasavska', selected: true },
      ],
      activeTab: 0,
      coverOpen: false,
      coverData: null,
      showAdvanced: false,
      searchInput: '',
      programs: [],
      sortKey: null,
      sortReverse: false,
      data_razpisi: null,
      data_programi: null,
      data_fundacije: null,
    };
  },
  computed: {
    selectedFilters() {
      return this.filters
        .filter(e => e.selected)
        .map(e => e.label);
    },
    uncheckAllText() {
      if (this.selectedFilters.length === 0) {
        return 'obkljukaj vse';
      }
      return 'odkljukaj vse';
    },
    selectedFiltersType() {
      return this.filtersType
        .filter(e => e.selected)
        .map(e => e.label);
    },
    selectedFiltersRegion() {
      return this.filtersRegion
        .filter(e => e.selected)
        .map(e => e.label);
    },
    isSelectedEU() {
      return this.selectedFiltersType.indexOf('EU') !== -1;
    },
    isSelectedSLO() {
      return this.selectedFiltersType.indexOf('SLO') !== -1;
    },
    selectedPrograms() {
      return this.programs
        .filter(e => e.selected);
    },
    programsPlaceholder() {
      const selected = this.selectedPrograms.length;
      if (!selected || selected === this.programs.length) {
        return 'Vsi programi!';
      }
      return `Izbrani programi: ${selected}`;
    },
    filteredRazpisi() {
      if (this.data_razpisi) {
        let filtered = this.data_razpisi
          .filter(e => e.podrocja && e.podrocja.some(v => this.selectedFilters.indexOf(v) !== -1))
          .filter(e => this.selectedFiltersType.indexOf(e.vrsta) !== -1)
          .filter((e) => {
            if (e.vrsta === 'SLO') {
              const selected = this.selectedFiltersRegion.length;
              if (!selected || selected === this.filtersRegion.length) {
                return true;
              }
              return (e.regije.some(v => this.selectedFiltersRegion.indexOf(v) !== -1));
            }
            return true;
          })
          .filter((e) => {
            const selected = this.selectedPrograms.length;
            if (!selected || selected === this.programs.length) {
              return true;
            }
            const intersection = _.intersectionBy(this.selectedPrograms, e.program, 'id');
            return intersection.length > 0;
          });
        if (this.searchInput) {
          filtered = filtered
            .filter(e => e.naziv.toLowerCase().indexOf(this.searchInput.toLowerCase()) !== -1);
        }
        if (this.sortKey) {
          filtered = _.sortBy(filtered, [(o) => {
            const val = _.get(o, this.sortKey);
            if (typeof val === 'string') {
              return val.toLowerCase();
            }
            return val;
          }]);
          if (this.sortReverse) {
            filtered = filtered.reverse();
          }
        }
        return filtered;
      }
      return this.data_razpisi;
    },
    filteredProgrami() {
      if (this.data_programi) {
        let filtered = this.data_programi
          .filter(e => e.podrocja && e.podrocja.some(v => this.selectedFilters.indexOf(v) !== -1));
        if (this.sortKey) {
          filtered = _.sortBy(filtered, [(o) => {
            const val = _.get(o, this.sortKey);
            if (typeof val === 'string') {
              return val.toLowerCase();
            }
            return val;
          }]);
          if (this.sortReverse) {
            filtered = filtered.reverse();
          }
        }
        return filtered;
      }
      return this.data_programi;
    },
    filteredFundacije() {
      if (this.data_fundacije) {
        let filtered = this.data_fundacije
          .filter(e => e.podrocja && e.podrocja.some(v => this.selectedFilters.indexOf(v) !== -1));
        if (this.sortKey) {
          filtered = _.sortBy(filtered, [(o) => {
            const val = _.get(o, this.sortKey);
            if (typeof val === 'string') {
              return val.toLowerCase();
            }
            return val;
          }]);
          if (this.sortReverse) {
            filtered = filtered.reverse();
          }
        }
        return filtered;
      }
      return this.data_fundacije;
    },
  },
  watch: {
    coverOpen(value) {
      const scroller = document.scrollingElement || document.documentElement;
      if (value) {
        scroller.style.overflow = 'hidden';
      } else {
        scroller.style.overflow = '';
      }
    },
    data_razpisi(value) {
      if (value && value.length && (!this.programs || !this.programs.length)) {
        const arrays = value
          .filter(e => e.program && e.program.length)
          .map(e => e.program);
        const array = _.concat(...arrays);
        const programs = _.uniqBy(array, 'id');
        this.programs = programs;
      } else if (!this.programs) {
        this.programs = [];
      }
    },
    data_programi(value) {
      if (value && value.length) {
        this.programs = value.map(program => ({
          id: program.id,
          label: program.naziv,
        }));
      } else if (!this.programs) {
        this.programs = [];
      }
    },
    filteredRazpisi(value, oldValue) {
      if (oldValue != null && typeof window != 'undefined') {
        console.log("filteredRazpisi changed!");
        const $body = $(document.body);
        $body.append('<div class="sr-only" aria-live="polite">Vsebina tabele z razpisi spremenjena.</div>');
      }
    },
  },
  methods: {
    changeTab(index) {
      this.activeTab = index;
      if (index !== 0 && this.showAdvanced) {
        this.toggleAdvanced();
      }
      this.sortKey = null;
      this.sortReverse = false;

      if ('pushState' in window.history) {
        window.history.pushState(null, '', this.tabs[index].link);
        this.locationChange(window.location);
      }
    },
    openCover(event, data, type) {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
        return;
      }
      event.preventDefault();
      this.coverData = data;
      this.coverOpen = true;
      if ('pushState' in window.history) {
        window.history.pushState(null, '', `/razpisi/${type}/${data.id}/${data.slug}`);
        this.locationChange(window.location);
      }
    },
    closeCover() {
      this.coverOpen = false;
      if ('pushState' in window.history) {
        window.history.pushState(null, '', this.tabs[this.activeTab].link);
        this.locationChange(window.location);
      }
    },
    uncheckAll() {
      let value = false;
      if (this.selectedFilters.length === 0) {
        value = true;
      }
      this.filters.forEach((filter) => {
        filter.selected = value;
      });
    },
    toggleAdvanced() {
      this.showAdvanced = !this.showAdvanced;
      if (!this.showAdvanced) {
        this.resetAdvanced();
      }
    },
    resetAdvanced() {
      this.filtersType.forEach((filter) => {
        filter.selected = true;
      });
      this.filtersRegion.forEach((filter) => {
        filter.selected = true;
      });
      if (this.euPrograms) {
        this.euPrograms.forEach((filter) => {
          filter.selected = false;
        });
      }
      this.searchInput = '';
    },
    fetchData(url, key) {
      $.getJSON(url).done((data) => {
        this[key] = data;
      }).fail(() => {
        const arr = [];
        arr.error = true;
        this[key] = arr;
      });
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortReverse = !this.sortReverse;
      } else {
        this.sortKey = key;
        this.sortReverse = false;
      }
    },
    locationChange(loc) {
      if (loc.pathname === '/razpisi/') {
        if (!this.data_razpisi) {
          this.fetchData('/razpisi/getActiveRazpises/', 'data_razpisi');
        }
        if (!this.data_programi) {
          this.fetchData('/razpisi/getActivePrograms/', 'data_programi');
        }
        this.coverOpen = false;
        this.coverData = null;
        this.activeTab = 0;
        if (!this.sortKey) {
          this.sortKey = 'datum_objave';
          this.sortReverse = true;
        }
      } else if (loc.pathname === '/razpisi/programi/') {
        if (!this.data_programi) {
          this.fetchData('/razpisi/getActivePrograms/', 'data_programi');
        }
        this.coverOpen = false;
        this.coverData = null;
        this.activeTab = 1;
        if (!this.sortKey) {
          this.sortKey = 'naziv';
          this.sortReverse = false;
        }
      } else if (loc.pathname === '/razpisi/fundacije/') {
        if (!this.data_fundacije) {
          this.fetchData('/razpisi/getActiveFundations/', 'data_fundacije');
        }
        this.coverOpen = false;
        this.coverData = null;
        this.activeTab = 2;
        if (!this.sortKey) {
          this.sortKey = 'naziv';
          this.sortReverse = false;
        }
      } else {
        const m = loc.pathname.match(/\/(razpis|program|fundacija)\/(\d+)\/.*$/);
        if (m && m[1] && m[2]) {
          const id = parseInt(m[2], 10);
          if (m[1] === 'razpis') {
            $.getJSON(`/razpisi/getRazpis/${id}/`).done((data) => {
              const res = splitFirstParagraph(data.opis);
              if (res.length === 2) {
                data.opis = res[0];
                data.opis_ostalo = res[1];
              }
              this.coverData = data;
              this.coverOpen = true;
            });
          } else if (m[1] === 'program') {
            $.getJSON(`/razpisi/getProgram/${id}/`).done((data) => {
              const res = splitFirstParagraph(data.opis);
              if (res.length === 2) {
                data.opis = res[0];
                data.opis_ostalo = res[1];
              }
              this.coverData = data;
              this.coverOpen = true;
            });
          } else if (m[1] === 'fundacija') {
            $.getJSON(`/razpisi/getFundation/${id}/`).done((data) => {
              const res = splitFirstParagraph(data.opis);
              if (res.length === 2) {
                data.opis = res[0];
                data.opis_ostalo = res[1];
              }
              this.coverData = data;
              this.coverOpen = true;
            });
          }
        }
      }
    },
    getDateDisplay(date) {
      if (date) {
        return new Date(date).toLocaleDateString('sl');
      }
      return '/';
    },
  },
  directives: {
    externallinks(el) {
      $(el).find('a[href^="http://"],a[href^="https://"]').attr('target', '_blank');
    },
    tooltips(el) {
      $(el).find('[data-toggle="tooltip"]').tooltip({
        container: 'body',
      });

      $(el).find('.bootstrap-accordion-title').each(function fixCollapsedClass() {
        const $this = $(this);
        const $body = $this.closest('.panel').find('.panel-collapse.collapse');
        $this.toggleClass('collapsed', !$body.hasClass('in'));
      });

      $(el).find('[data-toggle="collapse"]').collapse();

      $(el).find('.accordion-parent').on('show.bs.collapse', '.panel', function onShown() {
        const $panel = $(this).closest('.panel');
        $('html, body').animate({
          scrollTop: $panel.offset().top,
        }, {
          duration: 350,
          step: (now, tween) => {
            tween.end = $panel.offset().top;
          },
        });
      });
    },
    sortarrow: {
      bind(el, binding, vnode) {
        el.sortArrowListener = () => {
          vnode.context.sortBy(binding.value);
        };
        el.addEventListener('click', el.sortArrowListener);
        el.classList.add('sortarrow');
        if (binding.value === vnode.context.sortKey) {
          el.classList.add('sortarrow--active');
          if (vnode.context.sortReverse) {
            el.classList.add('sortarrow--reverse');
          } else {
            el.classList.remove('sortarrow--reverse');
          }
        } else {
          el.classList.remove('sortarrow--active');
          el.classList.remove('sortarrow--reverse');
        }
      },
      update(el, binding, vnode) {
        if (binding.value === vnode.context.sortKey) {
          el.classList.add('sortarrow--active');
          if (vnode.context.sortReverse) {
            el.classList.add('sortarrow--reverse');
          } else {
            el.classList.remove('sortarrow--reverse');
          }
        } else {
          el.classList.remove('sortarrow--active');
          el.classList.remove('sortarrow--reverse');
        }
      },
      unbind(el) {
        el.removeEventListener('click', el.sortArrowListener);
        el.sortArrowListener = null;
      },
    },
    footerclone(el) {
      const appFooter = document.getElementsByClassName('app__footer');
      if (appFooter && appFooter[0]) {
        el.innerHTML = appFooter[0].outerHTML;
        const select = el.getElementsByTagName('select')[0];
        const input = el.getElementsByTagName('input')[0];
        if (window.onFooterEmailSelectChange) {
          window.onFooterEmailSelectChange(select, input);
        }
      }
    },
    breadcrumbsclone(el) {
      const pageBreadcrumbs = document.getElementsByClassName('page-breadcrumbs');
      if (pageBreadcrumbs && pageBreadcrumbs[0]) {
        el.innerHTML = pageBreadcrumbs[0].innerHTML;
      }
    },
  },
  components: {
    SearchDropdown,
  },
};
</script>



// WEBPACK FOOTER //
// src/Razpisi.vue